module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%= headline %></h3> <div class=\"winner-wrapper\"> <p class=\"winner-copy\"><%- winnerCopy %></p> <p><%= paragraph2 %></p> </div> <div class=\"winner-image\"> <img src=\"<%= image %>\"> </div> <% if(isButtonEnabled) { %> <div class=\"button\"> <a href=\"<%= button_url %>\" target=\"_blank\" rel=\"noopener noreferrer\"><%= button_copy %></a> </div> <% } %> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', escape((__stack.lineno=1,  headline )), '</h3> <div class="winner-wrapper"> <p class="winner-copy">', (__stack.lineno=1,  winnerCopy ), '</p> <p>', escape((__stack.lineno=1,  paragraph2 )), '</p> </div> <div class="winner-image"> <img src="', escape((__stack.lineno=1,  image )), '"> </div> ');__stack.lineno=1; if(isButtonEnabled) { ; buf.push(' <div class="button"> <a href="', escape((__stack.lineno=1,  button_url )), '" target="_blank" rel="noopener noreferrer">', escape((__stack.lineno=1,  button_copy )), '</a> </div> ');__stack.lineno=1; } ; buf.push(' '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/winner.ejs
// module id = 264
// module chunks = 0